import React from "react";
import { roadmapSVGs } from '../../svgs/roadmap/index';

export default function MobileContainer() {
  return (
    <div
      className="flex flex-col font-Helvetica mx-auto w-full max-w-sm lg:hidden"
    >
      <div className="mb-12 self-start">
        <div className="font-Red-Undead text-7xl ml-8">1</div>
        <div className="flex relative w-[200px] h-[130px]">
          <div className="absolute">
            <roadmapSVGs.Div1 />
          </div>
          <div className="text-[11px] m-auto ml-10">
            Develop Beta game
            <br />
            Create token
            <br />
            Make strategic partnerships
            <br />
            Develop website
          </div>
        </div>
        <div className=" font-bold uppercase text-center text-3xl">
          phase
        </div>
      </div>

      <div className="mb-20 self-end">
        <div className="font-Red-Undead text-8xl text-center ml-8">
          2
        </div>
        <div className="flex relative w-[320px] h-[195px]">
          <div className="absolute">
            <roadmapSVGs.Div2 />
          </div>
          <div className="text-xs m-auto ml-12 leading-5">
            Community building
            <br />
            Partnership With Hulk Calls
            <br />
            Launch of the beta game for public
            <br />
            Create the PURGE ARMY
            <br />
            Game characters go live on the BSC <br />
            network and will give access to the game.
          </div>
        </div>
        <div className=" font-bold uppercase text-left text-4xl ml-14">
          phase
        </div>
      </div>

      <div className="mb-20 self-start">
        <div className="font-Red-Undead text-7xl ml-8">3</div>
        <div className="flex relative w-[320px] h-[145px]">
          <div className="absolute">
            <roadmapSVGs.Div3 />
          </div>
          <div className="text-[10px] m-auto ml-10 ">
            Partnership with Pinksale and their team
            <br />
            Open presale
            <br />
            Game activities and giveaways
            <br />
            Partnerships with NFT marketplaces and communities
            <br />
            Staking protocol for passive income on $PURGE
          </div>
        </div>
        <div className=" font-bold uppercase text-right text-3xl mr-12">
          phase
        </div>
      </div>
      <div className="max-[400px]:-mb-32 mb-28 self-center">
        <div className="font-Red-Undead text-7xl ml-8">4</div>
        <div className="flex relative w-[327px] h-[155px] my-2">
          <div className="absolute">
            <roadmapSVGs.Div4 />
          </div>
          <div className="text-xs m-auto ml-10 ">
            Token launch
            <br />
            Development of new in-game characters
            <br />
            Grow the PURGE army
            <br />
            Public leaderboard
            <br />
            Partnerships with other gaming communities
          </div>
        </div>
        <div className=" font-bold uppercase text-right text-4xl mr-8">
          phase
        </div>
      </div>
    </div>
  );
}
